import { lazy } from 'react';

export const overallScoreInputType = 'overall_scale';
export const yourEvaluationTab = 'your_evaluation';
export const allEvaluationsTab = 'all_evaluations';
export const evaluationsSummaryTab = 'evaluations_summary';
export const overallScoreAttribute = 'overall_step_score';

export const tabComponents = {
    [yourEvaluationTab]: {
        component: lazy(() => import('./EvaluationForm')),
        keys: [
            'selectedCriteria',
            'selectedStepEvaluation',
            'onStepEvaluationChange',
            'onSaveHandler',
            'readOnly',
        ],
    },
    [evaluationsSummaryTab]: {
        component: lazy(() => import('./CompetenceSummary')),
        keys: ['summary'],
    },
    [allEvaluationsTab]: {
        component: lazy(() => import('./IndividualEvaluations')),
        keys: ['summary'],
    },
};

export const DEFAULT_SECTION_ID = 'my_evaluations';